import { GameTable } from "./components/GameTable";
import "./index.css";

export function App() {
  return <GameTable />;
}

export default App;
